const returnSavedCarsWithRequiredData = myCars => {
  const filteredSavedCars = myCars.map(v => {
    const {
      vehicle_details: vehicleDetails
    } = v;
    return {
      ...v,
      vehicle_details: {
        latest_zipcode: vehicleDetails?.latest_zipcode || ''
      }
    };
  }).filter(v => v.vehicle_details.latest_zipcode && v.kbb_vehicle_id);
  return filteredSavedCars.length;
};
export default function hydrateMyCarsActionCreator(userDuck, personalization) {
  return () => async dispatch => {
    try {
      const myCars = await personalization.getUserOwnedVehicles();
      const myCarsCount = myCars?.length ? returnSavedCarsWithRequiredData(myCars) : 0;
      dispatch({
        type: userDuck.types.SET_CARS_I_OWN_COUNT,
        payload: myCarsCount
      });
      return myCarsCount || 0;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }
    return [];
  };
}